import axios from 'axios';

const importExcelApi = async (token, values, url) => {
  try {
    const res = await axios.post(url, values, {
      headers: {
        lang: 'ar',
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + token
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default importExcelApi;
